import * as e from "react";
const a = (t) => /* @__PURE__ */ e.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", width: "1em", height: "1em", ...t }, /* @__PURE__ */ e.createElement("path", { fillRule: "evenodd", d: "M14.126 9H3V7h11.126A4.002 4.002 0 0 1 22 8a4 4 0 0 1-7.874 1ZM16 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-6.126 7H21v2H9.874A4.002 4.002 0 0 1 2 16a4 4 0 0 1 7.874-1ZM8 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z", clipRule: "evenodd" }));
export {
  a as ReactComponent
};
